import {Button, HStack} from "@chakra-ui/react";
import T from "platformed-components/i18n/T";
import {usePromiseState} from "../../hooks/promiseState";
import {withDialog} from "../../state/withDialog";
import {DialogBody, DialogFooter, DialogHeader, DialogTitle} from "../../components/ui/dialog";

export type ConfirmationDialogProps = {
  onConfirm: () => Promise<unknown>;

  dialogHeader: React.ReactNode;
  dialogBody: React.ReactNode;
  buttonLabel: React.ReactNode;
  colorPalette?: string;
};

const ConfirmationDialog = withDialog(
  ({
    onClose,
    onConfirm,
    dialogHeader,
    dialogBody,
    buttonLabel,
    colorPalette = "red",
  }: ConfirmationDialogProps & {onClose: () => void}) => {
    const [confirming, confirm] = usePromiseState(async () => {
      await onConfirm();
      onClose();
    }, [onConfirm, onClose]);
    return (
      <>
        <DialogHeader>
          <DialogTitle>{dialogHeader}</DialogTitle>
        </DialogHeader>
        <DialogBody fontSize="md">{dialogBody}</DialogBody>
        <DialogFooter>
          <HStack gap="3">
            <Button variant="ghost" onClick={onClose}>
              <T keyName="c.Cancel" />
            </Button>
            <Button
              colorPalette={colorPalette}
              disabled={confirming.inProgress}
              onClick={confirm}
              loading={confirming.inProgress}
            >
              {buttonLabel}
            </Button>
          </HStack>
        </DialogFooter>
      </>
    );
  },
);

export default ConfirmationDialog;
